import {SetupContext} from "@vue/composition-api";
import { i18n } from "@/utilities/vue-i18n";
import {confirmDialogue} from "@/functions/system-modal-functions";

export function onNavigatingAway(context: SetupContext, preventCallback: () => boolean): () => void {

    const message = i18n.t('dialogue.unsaved-data') as string;

    const title = i18n.t('dialogue.unsaved-data-title') as string;

    let active = true;

    const cancel = context.root.$router.beforeEach(async (to, from, next) => {

        if (active) {

            const prevent = preventCallback();

            if (prevent && !(await confirmDialogue(title, message))) {

                next(false);

            } else {

                next();
            }
        }
        else
        {
            next();
        }
    });

    const onBeforeUnload = (e: Event) => {

        const prevent = preventCallback();

        if (prevent) {

            e.preventDefault();

            e.returnValue = false;
        }
    }

    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {

        active = false;

        cancel();

        window.removeEventListener('beforeunload', onBeforeUnload);
    }
}

export async function navigateToSettings(context: SetupContext) {

    await context.root.$router.push(`/${context.root.$route.params.company}/settings`);
}
